import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Spacer,
  Spinner,
  VStack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import UploadMutiFile from "../components/UploadFileShape";
import { IRanhGioiDuong } from "../_types_";
import { getToast } from "../utils";
import { themMoiRanhGioiDuong } from "../apis/he.so.dieu.chinh.api";
import { useGlobal } from "../contexts/Globals";

export default function RanhGioiTuyenDuongForm() {
  const toast = useToast();
  const { isHasEditRole } = useGlobal();
  const [model, setModel] = useState<IRanhGioiDuong>({});
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleOnChange = (field: string, value: string | number) => {
    if (!model) return;
    const newModel = { ...model };
    newModel[field] = value;
    setModel(newModel);
  };

  const handleSave = async () => {
    try {
      onOpen();
      const rs = await themMoiRanhGioiDuong(model);

      toast(
        getToast(
          "Thêm mới ranh giới tuyến đường đường thành công",
          "success",
          "Ranh giới Đường"
        )
      );
      setModel({});
    } catch (ex: any) {
      toast(getToast(`${ex}`, "error", "Ranh giới Đường"));
    }
    onClose();
  };

  return (
    <FormControl>
      <FormLabel>Đơn vị hành chính</FormLabel>
      <Input
        bgColor="white"
        value={model?.huyen}
        onChange={(e) => handleOnChange("huyen", e.target.value)}
      />
      <HStack w="full" mt="5px" mb="10px">
        <VStack flex={1} alignItems="flex-start">
          <FormLabel>Loại đường</FormLabel>
          <Input
            bgColor="white"
            type="number"
            value={model?.loaiDuong}
            onChange={(e) =>
              handleOnChange("loaiDuong", Number(e.target.value))
            }
          />
        </VStack>
      </HStack>
      <UploadMutiFile
        title="Ranh giới tuyến đường"
        isTimTuyenDuong
        onUploadSuccess={(f) => {
          if (model) {
            const newModel = { ...model, geo: f as string };
            setModel(newModel);
          }
        }}
      />

      {isHasEditRole && (
        <HStack mt="10px">
          <Spacer />
          <Button
            bg="blue.900"
            borderRadius="0px"
            color="white"
            textTransform="capitalize"
            onClick={handleSave}
            disabled={isOpen}
          >
            {isOpen && <Spinner />}
            {!isOpen && `Lưu Ranh giới đường`}
          </Button>
        </HStack>
      )}
    </FormControl>
  );
}
